/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EquipmentDto = {
    chassisAxles?: EquipmentDto.chassisAxles;
    chassisNumber?: string;
    chassisSize?: EquipmentDto.chassisSize;
    equipmentType?: EquipmentDto.equipmentType;
    gensetType?: EquipmentDto.gensetType;
    id?: string;
};
export namespace EquipmentDto {
    export enum chassisAxles {
        TWO_AXLES = 'TWO_AXLES',
        THREE_AXLES = 'THREE_AXLES',
    }
    export enum chassisSize {
        TWENTY_FT = 'TWENTY_FT',
        FORTY_FT = 'FORTY_FT',
        TWENTY_FORTY_FT = 'TWENTY_FORTY_FT',
        FORTY_FORTY_FIVE_FT = 'FORTY_FORTY_FIVE_FT',
        FORTY_FIVE_FT = 'FORTY_FIVE_FT',
    }
    export enum equipmentType {
        FLATBED_TRAILER = 'FLATBED_TRAILER',
        DRY_VANS = 'DRY_VANS',
        REFRIGERATED_TRAILER = 'REFRIGERATED_TRAILER',
        LOWBOY_TRAILER = 'LOWBOY_TRAILER',
        STEP_DECK_TRAILER = 'STEP_DECK_TRAILER',
        EXTENDABLE_FLATBED_TRAILER = 'EXTENDABLE_FLATBED_TRAILER',
        STRETCH_SINGLE_DROP_DECK_TRAILER = 'STRETCH_SINGLE_DROP_DECK_TRAILER',
        REMOVABLE_GOOSENECK_TRAILER = 'REMOVABLE_GOOSENECK_TRAILER',
        SPECIALTY_TRAILER = 'SPECIALTY_TRAILER',
        SIDEKIT_TRAILER = 'SIDEKIT_TRAILER',
        EXTENDABLE_DOUBLE_DROP_TRAILER = 'EXTENDABLE_DOUBLE_DROP_TRAILER',
        STRETCH_RNG_TRAILER = 'STRETCH_RNG_TRAILER',
        CONESTOGA_TRAILER = 'CONESTOGA_TRAILER',
        POWER_ONLY_TRAILER = 'POWER_ONLY_TRAILER',
        MULTI_CAR_TRAILER = 'MULTI_CAR_TRAILER',
        SPECIALIZED_TRAILER = 'SPECIALIZED_TRAILER',
        OCEAN_CONTAINER_CHASSIS = 'OCEAN_CONTAINER_CHASSIS',
        GENSET = 'GENSET',
    }
    export enum gensetType {
        UNDERSLUNG = 'UNDERSLUNG',
        CLIP_ON = 'CLIP_ON',
    }
}

